import React from "react";
import { Navbar } from "src/components/home/Navbar";
import { HeroSection } from "src/components/home/HeroSection";
import { StatsMarquee } from "src/components/home/StatsMarquee";
import { ModulesSection } from "src/components/home/ModulesSection";
import { ChallengeSection } from "src/components/home/ChallengeSection";
import { ContactSection } from "src/components/home/ContactSection";
import { BackgroundBlobs } from "src/components/home/BackgroundBlobs";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#05081D] font-sans text-white antialiased">
      {/* Ambient background glows */}
      <BackgroundBlobs />

      {/* Fixed transparent/blur navigation */}
      <Navbar />

      {/* Page content — sits above background blobs */}
      <main className="relative z-10">
        {/* Contain hero */}
        <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
          <HeroSection />
        </div>

        {/* Full-bleed Stats & Logos Marquee */}
        <StatsMarquee />

        {/* Modules Highlights (Pre-Sales, Sales, Post-Sales) */}
        <ModulesSection />

        {/* Why Teams Need AI Challenge Section */}
        <div className="border-t border-white/5 bg-white/[0.01]">
          <ChallengeSection />
        </div>

        {/* Contact Us / Book Demo Form */}
        <div className="border-t border-white/5">
          <ContactSection />
        </div>
      </main>
    </div>
  );
}
